import React from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faChevronUp,
} from "@fortawesome/free-solid-svg-icons";
export default function BuyOverview({isReadMore ,propData ,contentRef ,visibleReadmore,setIsReadMore}) {
  return (
    <div className="property-overview-details property-details-block">
                    <div className="row">
                      <div className="col-12">
                        <div className="property-overview-detail">
                          <h3>Overview</h3>
                          <div
                            className={`overview-description ${
                              isReadMore ? "expanded" : ""
                            }`}
                            dangerouslySetInnerHTML={{
                              __html:
                                propData?.propertyDTO?.aboutProperty ||
                                "No Data Found",
                            }}
                            ref={contentRef}
                          >
                            
                          </div>
                          {visibleReadmore && (
                            <div
                              className="overview-readmore"
                              onClick={() => setIsReadMore(!isReadMore)}
                            >
                              <span className="readmore">
                                {isReadMore ? "Read Less" : "Read More"}
                                <FontAwesomeIcon
                                  className="ms-1"
                                  icon={isReadMore ? faChevronUp : faChevronDown}
                                />
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
  )
}
